<template>
  <div class="box">
    <div v-if="title" class="box__title">
      {{ title }}
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompaniesSurveyTemplateFormBorderBox',
  props: {
    title: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  border: 1px solid #E4E7EB;
  border-radius: 4px;
  padding: 24px;
  &__title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 16px;
  }
}
</style>
